
export enum UserPrimaryEmailSourceEnum {
  GITLAB = 'GITLAB',
  GITHUB = 'GITHUB',
  GOOGLE = 'GOOGLE',
  LOCAL = 'LOCAL',
}
